import { setActivePet } from '../utils/initialize';
import {
	SET_ACTIVE_PET,
	SET_ACTIVE_PET_TYPE,
	SET_KITTEN,
	SET_SHUFFLE_PETS,
} from '../constants';

const initialState = setActivePet();

const activePet = (state = initialState, action) => {
	switch (action.type) {
		case SET_ACTIVE_PET:
			return {
				...state,
				active: {
					...state.active,
					...action.payload.pet,
				},
			};
		case SET_ACTIVE_PET_TYPE:
			return {
				...state,
				active: {
					...state.active,
					petType: action.payload.petType,
				},
			};
		case SET_KITTEN:
			return {
				...state,
				active: {
					...state.active,
					kitten: action.payload.kitten,
				},
			};
		case SET_SHUFFLE_PETS:
			return {
				...state,
				shuffle: action.payload.isShuffle,
			};
		default:
			return state;
	}
};

export default activePet;



// WEBPACK FOOTER //
// ./src/reducers/activePet.js